<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Stages</li>
                </ol>
                <h4 class="main-title mb-0">Stages</h4>
            </div>
            <router-link to="/stages/create" v-can="'stages.create'" type="submit" class="btn btn-primary" ><i class="ri-list-check fs-18 lh-1"></i> Add Stage</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Stages</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-striped table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('stage_name')">
                                            Stage Name
                                            <span>
                                                <i v-if="meta.keyword == 'stage_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'stage_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('stage_type')">
                                            Stage Type
                                            <span>
                                                <i v-if="meta.keyword == 'stage_type' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'stage_type' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>Loading Type</th>
                                        <th @click="sort('order')">
                                            Order
                                            <span>
                                                <i v-if="meta.keyword == 'order' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'order' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'stages.delete'">Status</th>
                                        <th class="text-center" v-can="'stages.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="stages.length==0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="stage, key in stages" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ stage.stage_name}}</td>
                                        <td>{{ stage.stage_type}}</td>
                                        <td>{{ stage?.loading_type?.loading_type_name }}</td>
                                        <td>{{ stage.order }}</td>
                                        <td class="text-center" v-can="'stages.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'stage' + stage.stage_id" :checked="stage.status" :value="stage.status" @change="deleteStage(stage)" />
                                                <label class="custom-control-label" :for="'stage' + stage.stage_id"></label>
                                            </div>
                                        </td>
                                         <td class="text-center" v-can="'stages.update'">
                                            <nav>
                                                <a href="javascript:void(0)" v-if="stage.status" class="text-success me-2" @click.prevent="edit(stage)" :disabled="!stage.status"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            </nav>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "stage_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },

                stages: [],
                errors: [],
                // update: false,
                status: true,
            };
        },
        mounted() {
            this.index();
        },

        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateStages", data: vm.meta })
                    .then((response) => {
                        vm.stages = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            edit(stage) {
                this.$router.push("/stages/" + stage.stage_id + "/edit");
            },
            deleteStage(stage) {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "deleteStage", data: stage })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
